<template>
    <div>
        <el-select v-model="select" filterable :placeholder="config.placeholder" clearable @change="handleCheck">
            <el-option v-for="(item, index) in config.list" :key="index" :label="`${item.name}`" :value="item.name">
            </el-option>
        </el-select>
        <!-- 弹出框 -->
        <FormDialog :visible.sync="showDialog" :content="content" />
    </div>
</template>

<script>
import { isEmpty } from '@/utils'
import FormDialog from '@/components/dialog'
export default {
    name: 'FormSelect',
    components: {
        FormDialog
    },
    props: {
        value: {
            type: String,
            default: ''
        },
        config: {
            type: Object,
            default: {}
        }
    },
    model: {
        event: 'change'
    },
    watch: {
        select(value) {
            this.$emit('change', value)
        },
        value(value) {
            this.select = value
        }
    },
    data() {
        return {
            select: this.value,
            showDialog: false,
            content: '',
        }
    },
    methods: {
        handleCheck(value) {
            const item = this.config.list.find(v => v.name == value);
            if (!isEmpty(item.tips)) {
                this.content = item.tips;
                this.showDialog = true;
            }
            return;
        }
    }
}
</script>
